import Edit from 'assets/Icons/edit';
import Box from 'components/Box';
import Text from 'components/Text';
import colorTheme from 'constants/color';
import { IAppointmentServiceItem, IAptDetailCustomerItem } from 'features/appointment/services/types/appointment';
import styled from 'styled-components';
import ServicesStaff from './ServicesStaff';
type Props = {
  value?: IAptDetailCustomerItem;
  onChange?: (value?: IAptDetailCustomerItem) => void;
  name?: any;
  single?: boolean;
  onEditName: (value?: IAptDetailCustomerItem, onChange?: (value: IAptDetailCustomerItem) => void) => void;
  index: number;
  onChangeStaff: (currentStaffId: string, onChange: (staffId: string) => void) => void;
  onAddService: (add: (value?: IAppointmentServiceItem | undefined) => void) => void;
};
const CustomerDataItem = ({ index, single, name, onChange, value, onEditName, onAddService, onChangeStaff }: Props) => {
  return (
    <>
      <Container>
        {!single && <CustomerInfo type='button' onClick={(e: any) => [e.stopPropagation(), onEditName(value, onChange)]}>
          <Text className='label'>{index + 1}. Customer: {value?.name || (index + 1)}</Text>
          <div style={{ zoom: 1.5 }}><Edit fill={colorTheme.v2_secondary_3} /></div>
          <Text className='edit-text' color='v2_secondary_3' >Edit</Text>
        </CustomerInfo>}
        <ServicesStaff name={[name, 'services']}
          onChangeStaff={onChangeStaff}
          onAddService={onAddService}
          customer={value}
        />
      </Container>
    </>
  );
};

export default CustomerDataItem;

const Container = styled(Box)`
display: flex;
flex-direction: column;
padding: 16px;
`;

const CustomerInfo = styled.button`
display: flex;
align-items: center;
gap: 8px;
height: 32px;
.label, .edit-text {
  color: #505050;
  text-align: center;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 137.5%;
  letter-spacing: 0.36px;
}
  
.edit-text {
  color: #2D6772;
  font-size: 20px;
}

`;
